import { render, staticRenderFns } from "./NotesView.vue?vue&type=template&id=748bf714&scoped=true"
import script from "./NotesView.vue?vue&type=script&lang=js"
export * from "./NotesView.vue?vue&type=script&lang=js"
import style0 from "./NotesView.vue?vue&type=style&index=0&id=748bf714&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748bf714",
  null
  
)

export default component.exports